
(function () {
  'use strict';

  var MONEY_SELECTOR = '[data-price-current]';
  var IMG_SIZES = '(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw';
  function escapeAttr(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  class ProductCardThumbs extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-thumbs-track]');
      this.perView = parseFloat(this.dataset.perView) || 6;
      this.peek = parseFloat(this.dataset.peek) || 0;
      this.gap = parseInt(this.dataset.gap, 10) || 0;

      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);

      this.onFocusIn = this.onFocusIn.bind(this);
      this.addEventListener('focusin', this.onFocusIn);

      this.classList.add('product-card__thumbs--pending');

      if (!this.dataset.url || this.dataset.state === 'loaded') {
        this.syncVisibility();
        this.initCarousel();
        return;
      }

      var self = this;
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) return;
            self._observer.disconnect();
            self._observer = null;
            self.loadRecommendations();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );

        this._observer.observe(this.closest('.product-card') || this);
      } else {
        this.loadRecommendations();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('focusin', this.onFocusIn);
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._controller) this._controller.abort();
      this.destroyCarousel();
    }

    loadRecommendations() {
      if (this.dataset.state === 'loading' || this.dataset.state === 'loaded') return;
      this.dataset.state = 'loading';

      if (this._controller) this._controller.abort();
      this._controller = new AbortController();

      var self = this;
      fetch(this.dataset.url, { signal: this._controller.signal })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-thumbs-content]');
          self.dataset.state = 'loaded';
          if (content && content.children.length && self.track) {
            self.track.insertAdjacentHTML('beforeend', content.innerHTML);
          }
          self.syncVisibility();
          self.initCarousel();
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          self.dataset.state = 'loaded';
          self.syncVisibility();
          self.initCarousel();
        });
    }

    syncVisibility() {
      var count = this.track ? this.track.querySelectorAll('.product-card__thumb-slide').length : 0;
      this.classList.remove('product-card__thumbs--pending');
      var visible = count >= 1;
      this.hidden = !visible;
      var wrap = this.closest('.swatch_contaier');
      if (wrap && !wrap.querySelector('product-card-swatches')) {
        wrap.hidden = !visible;
      }
      return visible;
    }

    initCarousel(attempts) {
      if (!this.track || this.swiperInstance) return;
      if (!window.Swiper) {
        attempts = attempts || 0;
        if (attempts >= 40 || !this.isConnected) return;
        var self = this;
        setTimeout(function () {
          self.initCarousel(attempts + 1);
        }, 100);
        return;
      }

      this.swiperInstance = new window.Swiper(this, {
        slidesPerView: this.perView + this.peek,
        spaceBetween: this.gap,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        grabCursor: true,
        a11y: { slideRole: 'listitem' }
      });
    }

    destroyCarousel() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    /*
     * Focusing a partially clipped thumb (click or Tab)
     */
    onFocusIn(event) {
      var thumb = event.target.closest('.product-card__thumb');
      if (!thumb || !this.contains(thumb)) return;
      this.scrollLeft = 0;
      this.scrollTop = 0;
      var sw = this.swiperInstance;
      if (!sw) return;
      var slide = thumb.closest('.swiper-slide');
      var index = Array.prototype.slice.call(sw.slides).indexOf(slide);
      if (index < 0) return;
      var fullyVisible = Math.floor(sw.params.slidesPerView);
      var first = sw.activeIndex;
      if (index < first) {
        sw.slideTo(index);
      } else if (index >= first + fullyVisible) {
        sw.slideTo(index - fullyVisible + 1);
      }
    }

    onClick(event) {
      var thumb = event.target.closest('[data-switch]');
      if (!thumb || !this.contains(thumb)) return;
      event.preventDefault();
      this.switchTo(thumb);
    }

    switchTo(thumb) {
      var card = this.closest('.product-card');
      if (!card) return;
      var d = thumb.dataset;
      card.dataset.productId = d.productId || card.dataset.productId;
      card.dataset.productUrl = d.productUrl || card.dataset.productUrl;
      card.dataset.variantId = d.variantId || card.dataset.variantId;

      this.updateImage(card, d, thumb);
      this.updateTitle(card, d);
      this.updateVendor(card, d);
      this.updateDescription(card, d);
      this.updateBadges(card, d);
      this.updatePrice(card, d);
      this.updateLinks(card, d);
      this.updateAdd(card, d);
      var active = this.querySelector('.product-card__thumb.is-active');
      if (active) active.classList.remove('is-active');
      thumb.classList.add('is-active');
    }


    placeholderSvgHtml(thumb) {
      var svg = thumb && thumb.querySelector('svg');
      if (!svg) return '';
      var clone = svg.cloneNode(true);
      clone.setAttribute('class', 'product-card__placeholder-svg');
      return clone.outerHTML;
    }

    updateImage(card, d, thumb) {
      var swiper = card.querySelector('.product-card__swiper');
      if (swiper) {
        this.rebuildCarousel(card, swiper, d, thumb);
        return;
      }

      var link = card.querySelector('.product-card__media-link');
      if (!link) return;

      var primary =
        link.querySelector('.product-card__img--primary') ||
        link.querySelector('.product-card__img');
      var placeholder = link.querySelector('.product-card__placeholder');

      if (d.image) {
        if (primary) {
          primary.src = d.image;
          if (d.imageSrcset) primary.srcset = d.imageSrcset;
          if (d.imageAlt) primary.alt = d.imageAlt;
          primary.hidden = false;
        }
        if (placeholder) placeholder.hidden = true;
        this.updateSecondary(card, d);
        return;
      }


      if (primary) primary.hidden = true;
      this.updateSecondary(card, {});
      if (placeholder) placeholder.hidden = false;
    }

    updateSecondary(card, d) {
      var secondary = card.querySelector('.product-card__img--secondary');
      if (!secondary) return;

      if (d.secondaryImage) {
        secondary.src = d.secondaryImage;
        if (d.secondarySrcset) secondary.srcset = d.secondarySrcset;
        secondary.alt = d.secondaryAlt || d.imageAlt || '';
        secondary.hidden = false;
      } else {
        secondary.removeAttribute('src');
        secondary.removeAttribute('srcset');
        secondary.hidden = true;
      }
    }


    rebuildCarousel(card, swiper, d, thumb) {
      var wrapper = swiper.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      var images = [];
      try {
        images = JSON.parse(d.images || '[]');
      } catch (e) {
        images = [];
      }

      var ratioEl = wrapper.querySelector('.ratio');
      var ratioClass = ratioEl ? ratioEl.className : 'ratio ratio-1x1';
      var isAdapt = /(^|\s)ratio-auto(\s|$)/.test(ratioClass);
      var url = d.productUrl || card.dataset.productUrl || '#';
      var title = d.title || '';

      if (!images.length) {
        if (d.image) {
          var firstImg = wrapper.querySelector('.product-card__img');
          if (firstImg) {
            firstImg.src = d.image;
            if (d.imageSrcset) firstImg.srcset = d.imageSrcset;
            if (d.imageAlt) firstImg.alt = d.imageAlt;
          }
          return;
        }
        wrapper.innerHTML =
          '<div class="swiper-slide product-card__slide">' +
          '<div class="' + escapeAttr(ratioClass.replace(/(^|\s)ratio-auto(\s|$)/, ' ratio-1x1 ')) + '">' +
          '<a href="' + escapeAttr(url) + '" class="product-card__media-link" aria-label="' +
          escapeAttr(title) + '">' +
          '<div class="product-card__placeholder">' + this.placeholderSvgHtml(thumb) + '</div>' +
          '</a></div></div>';
        if (window.SectionCarousel && typeof window.SectionCarousel.reinit === 'function') {
          window.SectionCarousel.reinit(swiper);
        }
        return;
      }

      var html = '';
      for (var i = 0; i < images.length; i++) {
        var im = images[i];
        var ratioStyle = isAdapt
          ? ' style="--media-aspect-ratio:' + (parseFloat(im.ratio) || 100) + '%;"'
          : '';
        html +=
          '<div class="swiper-slide product-card__slide">' +
          '<div class="' + escapeAttr(ratioClass) + '"' + ratioStyle + '>' +
          '<a href="' + escapeAttr(url) + '" class="product-card__media-link" aria-label="' +
          escapeAttr(title) + '" tabindex="-1">' +
          '<img class="product-card__img" src="' + escapeAttr(im.src || '') + '" ' +
          'srcset="' + escapeAttr(im.srcset || '') + '" ' +
          'sizes="' + IMG_SIZES + '" ' +
          'loading="lazy" alt="' + escapeAttr(im.alt || title) + '">' +
          '</a></div></div>';
      }
      wrapper.innerHTML = html;
      if (window.SectionCarousel && typeof window.SectionCarousel.reinit === 'function') {
        window.SectionCarousel.reinit(swiper);
      }
    }

    updateTitle(card, d) {
      if (!d.title) return;
      var titles = card.querySelectorAll('.product-title a');
      for (var i = 0; i < titles.length; i++) {
        titles[i].textContent = d.title;
      }
    }

    updateVendor(card, d) {
      if (typeof d.vendor === 'undefined') return;
      var vendors = card.querySelectorAll('.product-vendor');
      for (var i = 0; i < vendors.length; i++) {
        vendors[i].textContent = d.vendor;
        vendors[i].hidden = !d.vendor;
      }
    }


    updateDescription(card, d) {
      if (typeof d.description === 'undefined') return;
      var raw = d.description || '';
      var wasTruncated = /\.\.\.$/.test(raw);
      var text = wasTruncated ? raw.replace(/\.\.\.$/, '').trim() : raw.trim();
      var words = text.split(/\s+/).filter(Boolean);

      var blocks = card.querySelectorAll('.product-description');
      for (var i = 0; i < blocks.length; i++) {
        var limit = parseInt(blocks[i].dataset.wordLimit, 10) || 5;
        var out = text;
        if (words.length > limit) {
          out = words.slice(0, limit).join(' ') + '...';
        } else if (wasTruncated && text) {
          out = text + '...';
        }
        blocks[i].textContent = out;
        blocks[i].hidden = !out;
      }
    }

    updateBadges(card, d) {
      var soldOut = d.soldOut === 'true';
      var show = {
        'sold-out': soldOut,
        sale: !soldOut && d.onSale === 'true',
        bestseller: !soldOut && d.bestseller === 'true',
        new: !soldOut && d.new === 'true'
      };
      var badges = card.querySelectorAll('[data-badge]');
      for (var i = 0; i < badges.length; i++) {
        var key = badges[i].dataset.badge;
        if (key in show) badges[i].hidden = !show[key];
      }
    }

    updatePrice(card, d) {
      var i;
      var onSale = d.onSale === 'true';

      var currents = card.querySelectorAll(MONEY_SELECTOR);
      for (i = 0; i < currents.length; i++) {
        if (d.price) currents[i].textContent = d.price;
        currents[i].classList.toggle('product-price__current--sale', onSale);
      }

      var compares = card.querySelectorAll('[data-price-compare]');
      for (i = 0; i < compares.length; i++) {
        if (onSale && d.comparePrice) {
          compares[i].textContent = d.comparePrice;
          compares[i].hidden = false;
        } else {
          compares[i].textContent = '';
          compares[i].hidden = true;
        }
      }

      var badges = card.querySelectorAll('[data-price-badge]');
      for (i = 0; i < badges.length; i++) {
        if (onSale && d.discount) {
          badges[i].textContent = (badges[i].dataset.textOff || '[[p]]% OFF').replace(
            '[[p]]',
            d.discount
          );
          badges[i].hidden = false;
        } else {
          badges[i].textContent = '';
          badges[i].hidden = true;
        }
      }


      var units = card.querySelectorAll('[data-unit-price]');
      for (i = 0; i < units.length; i++) {
        if (d.variantUnitPrice) {
          units[i].textContent = d.variantUnitPrice;
          units[i].hidden = false;
        } else {
          units[i].textContent = '';
          units[i].hidden = true;
        }
      }
    }

    updateLinks(card, d) {
      if (!d.productUrl) return;
      var links = card.querySelectorAll('a.product-card__media-link, a.product-card-add__btn--options');
      for (var i = 0; i < links.length; i++) {
        links[i].href = d.productUrl;
      }
      var quickViews = card.querySelectorAll('[data-quick-view-trigger]');
      for (var j = 0; j < quickViews.length; j++) {
        quickViews[j].dataset.productUrl = d.productUrl;
      }
    }


    updateAddMode(card, d) {
      if (typeof d.hasOnlyDefaultVariant === 'undefined' || typeof d.variantsCount === 'undefined') {
        return;
      }
      var i;
      var sellingPlan = d.sellingPlan === 'true';
      var quickAdd = d.hasOnlyDefaultVariant === 'true' && !sellingPlan;
      var singleVariant = d.variantsCount === '1' && !sellingPlan;

      var quickForms = card.querySelectorAll('[data-quick-add-form]');
      for (i = 0; i < quickForms.length; i++) quickForms[i].hidden = !quickAdd;
      var quickTriggers = card.querySelectorAll('[data-quick-view-trigger]');
      for (i = 0; i < quickTriggers.length; i++) quickTriggers[i].hidden = quickAdd;

      var wraps = card.querySelectorAll('.product-card-add');
      for (i = 0; i < wraps.length; i++) {
        var useForm = (singleVariant || wraps[i].dataset.forceForm === 'true') && !sellingPlan;
        var form = wraps[i].querySelector('[data-card-add-form]');
        if (form) form.hidden = !useForm;
        var options = wraps[i].querySelector('[data-card-add-options]');
        if (options) options.hidden = useForm;
      }
    }


    updateAdd(card, d) {
      var i;
      this.updateAddMode(card, d);

      var inputs = card.querySelectorAll('[data-variant-id-input]');
      for (i = 0; i < inputs.length; i++) {
        inputs[i].value = d.variantId || '';
        inputs[i].dataset.inventoryTracked = d.inventoryTracked || 'false';
        if (typeof d.inventoryQuantity !== 'undefined') {
          inputs[i].dataset.inventoryQuantity = d.inventoryQuantity;
        }
      }

      var available = d.available !== 'false';
      var buttons = card.querySelectorAll('form button[name="add"]');
      for (i = 0; i < buttons.length; i++) {
        var button = buttons[i];
        button.disabled = !available;
        button.classList.toggle('disabled', !available);
        var label =
          button.querySelector('[data-add-to-cart-text]') ||
          button.querySelector('.product-card__quick-view-icon-text');
        if (label) {
          label.textContent = available
            ? button.dataset.textAdd || label.textContent
            : button.dataset.textSoldout || label.textContent;
        }
        var icon = button.querySelector('.product-card-add__icon');
        if (icon) icon.hidden = !available;
      }
    }
  }

  if (!customElements.get('product-card-thumbs')) {
    customElements.define('product-card-thumbs', ProductCardThumbs);
  }
})();